import { useDispatch } from "react-redux";
import { Col, Form, Row } from "react-bootstrap";
import { setFontColor, setPrimaryColor, setSecondaryColor } from "../store/themeSlice";
import { Color } from "../interfaces/store";


const Theme: React.FC<Color>  = ({ primaryColor, secondaryColor, fontColor }) => {
    const dispatch = useDispatch();    
  
    return (
      <Row className="mb-3">
        <Col>
         <Form.Label> Primary Color </Form.Label>
         <Form.Control className='mb-2' placeholder="Primary Color" value={primaryColor} onChange={(e) => dispatch(setPrimaryColor(e.target.value))} />
         <Form.Label> Seconary Color </Form.Label>
         <Form.Control className='mb-2' placeholder="Secondary Color" value={secondaryColor} onChange={(e) =>dispatch(setSecondaryColor(e.target.value as any))} />
         <Form.Label> Font Color </Form.Label>
         <Form.Control className='mb-2' placeholder="Font Color" value={fontColor} onChange={(e) => dispatch(setFontColor(e.target.value))} />
        </Col>
      </Row>
    );
  };
  
  export default Theme;